/**
 *
 */
export function createDeviceSettingsState() {
    return {
        facingMode: 'user',
        microphoneAEC: true,
        microphoneAGC: true,
        microphoneANS: true,
    };
}
